import { Redirect, Route, Router, Switch } from "wouter";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { WagmiProvider } from "wagmi";
import { config } from "@/lib/wagmi";
import { ThemeProvider } from "@/lib/theme";
import { WalletUIProvider } from "@/lib/wallet-ui";
import { ErrorBoundary } from "@/components/error-boundary";
import Dapp from "@/pages/dapp";

const queryClient = new QueryClient();

export default function App() {
  return (
    <ErrorBoundary>
      <WagmiProvider config={config}>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider>
            <WalletUIProvider>
              <Router>
                <Switch>
                  <Route path="/app" component={Dapp} />
                  <Route path="/app/:tab" component={Dapp} />
                  <Route path="/">
                    <Redirect to="/app" />
                  </Route>
                  <Route>
                    <Redirect to="/app" />
                  </Route>
                </Switch>
              </Router>
            </WalletUIProvider>
          </ThemeProvider>
        </QueryClientProvider>
      </WagmiProvider>
    </ErrorBoundary>
  );
}
